import { gql } from '@apollo/client';
import _ from 'lodash';
import type { PopulatePostsWithFullTopics_PostsFragment } from '../graphql/generated/graphqlTypes';

const FRAGMENT = gql`
  fragment populatePostsWithFullTopics_posts on SlimPostFields {
    topics {
      id
    }
  }
`;

const populatePostsWithFullTopics = <
  Post extends PopulatePostsWithFullTopics_PostsFragment,
  Topic,
>(
  posts: Post[],
  topicMap: { [id: string]: Topic },
) =>
  posts.map(({ topics, ...post }) => ({
    ...post,
    topics: _.compact(topics?.map((topic) => topicMap[topic.id])),
  }));

populatePostsWithFullTopics.fragments = {
  posts: FRAGMENT,
};

export default populatePostsWithFullTopics;
